import {
  Box,
  Breadcrumbs,
  Container,
  Stack,
  styled,
  Typography,
  FormControlLabel,
  Radio,
  RadioGroup,
  Divider,
  Rating,
  Tooltip,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Table,
  TableContainer,
  Paper,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  TextField,
  InputLabel,
  InputBase,
  FormControl,
  FormHelperText,
  AppBar,
  Tabs,
  useMediaQuery,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import React, { useEffect, useState } from "react";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Keyboard, Pagination, Navigation } from "swiper";
import "swiper/css";
import img1 from "../assets/images/products/prod1.jpg";
import img2 from "../assets/images/products/prod2.jpg";
import img3 from "../assets/images/products/prod3.jpg";
// import img4 from "../assets/images/products/prod1_5.webp";
// import img5 from "../assets/images/products/prod1_6.webp";
// import img6 from "../assets/images/products/prod1_7.webp";
import depric1 from "../assets/images/labels/depric1_180x.avif";
import depric2 from "../assets/images/labels/depric2_180x.avif";
import depric3 from "../assets/images/labels/depric3_180x.avif";
import depric4 from "../assets/images/labels/depric4_180x.avif";
import depric5 from "../assets/images/labels/depric5_180x.png";
import depric6 from "../assets/images/labels/depric6_180x.avif";
import reason1 from "../assets/images/quality/reasons_1.webp";
import reason2 from "../assets/images/quality/reasons_2.webp";
import reason3 from "../assets/images/quality/reasons_3.png";
import reason4 from "../assets/images/quality/reasons_4.webp";
import reason5 from "../assets/images/quality/reasons_5.avif";
import { ReactComponent as Svg1 } from "../assets/svg/productWarn1.svg";
import { ReactComponent as Svg2 } from "../assets/svg/productWarn2.svg";
import { ReactComponent as Svg3 } from "../assets/svg/productWarn3.svg";
import { ReactComponent as Svg4 } from "../assets/svg/productWarn4.svg";
import { ReactComponent as Svg5 } from "../assets/svg/productWarn5.svg";
import { ReactComponent as Svg6 } from "../assets/svg/productWarn6.svg";
import { ReactComponent as Svg7 } from "../assets/svg/productWarn7.svg";
import { BsTruck } from "react-icons/bs";
import { SlLocationPin } from "react-icons/sl";
import { RiRefund2Line } from "react-icons/ri";
import { FaBarcode } from "react-icons/fa";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import ReactImageMagnify from "react-image-magnify";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { CiHeart } from "react-icons/ci";
import { alpha, fontWeight } from "@mui/system";
import sizeChart from "../assets/images/size_chart.avif";
import { useFormik, validateYupSchema } from "formik";
import { ValidationError } from "yup";
import * as Yup from "yup";
import {
  ProductsSelectionBox,
  StyledTab,
  TabPanel,
} from "../components/OurProducts";
import { useGetProductQuery } from "../services/queries";
import ProductDetailsSkelton from "../components/ProductDetailsSkelton";
import { addItem } from "../redux/Cart/CartReducer";
import { useDispatch, useSelector } from "react-redux";
import {
  toggleItemToWishlist,
  wishlistProductSelector,
} from "../redux/Wishlist/WishlistReducer";
import { FavoriteRounded } from "@mui/icons-material";
import { Helmet } from "react-helmet";
// commponents
const Wrapper = styled((props) => <Box {...props}>{props.children}</Box>)(
  ({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(4),
    margin: "20px 0",
    "& .image-magnify": {
      position: "relative",
      display: "flex",
      flex: 1,
      flexBasis: "50%",
      flexDirection: "row",
      height: "100%",
      gap: theme.spacing(1),

      "& .MuiFormGroup-root": {
        width: "80px",
        "& .swiper": {
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          width: "80px",
          marginLeft: 0,
          "& .swiper-wrapper": {
            // height: "150px",
            // width: "150px",
          },
          "& .swiper-slide": {
            height: "auto !important",
            "& .swiper-img": {
              opacity: 0.3,
              "&:hover": {
                cursor: "pointer",
                opacity: 0.8,
                transition: "opacity 1s",
              },
            },
            "& .selected-swiper-img": {
              border: `3px solid ${theme.palette.primary.main}`,
              padding: "1px",
            },
          },
          "& .swiper-button-prev , & .swiper-button-next": {
            top: "calc(100%)",
            transform: "translateY(-50%)",
          },
          "& .swiper-button-prev": {
            "&:after": { marginRight: "20px" },
          },
          "& .swiper-button-next": {
            "&:after": { marginLeft: "20px" },
          },
        },
      },
      "& .image-magnify-wrapper": {
        height: "auto",
        maxWidth: "100%",
        flex: 1,
        "& .imageMagnify-root": {
          width: "100% !important",
          maxHeight: "100% !important",
          height: "auto",
          "& .small-image": {
            height: "auto",
            width: "auto",
            // flex: 1,
            // maxWidth: "100% !important",
            // width: "100% !important",
            // height: "auto !important",
            // maxHeight: "100% !important",
          },
        },
      },
      //
    },
    //
    "@media (max-width:1025px)": {
      "& .image-magnify": {
        flexDirection: "column-reverse",
        "& .MuiFormGroup-root": {
          width: "auto",
          height: "125px",
          overflow: "hidden",
          position: "relative",
          "& .swiper": {
            position: "absolute",
            top: "0",
            width: "100%",
            left: 0,
            right: 0,
            height: "125px",
            bottom: 0,
            // overflow: "hidden",
            "& .swiper-wrapper": {
              // height: "150px",
              // width: "150px",
            },
            "& .swiper-slide": {
              height: "auto !important",
              "& .swiper-img": {
                opacity: 0.3,
                "&:hover": {
                  cursor: "pointer",
                  opacity: 0.8,
                  transition: "opacity 1s",
                },
              },
              "& .selected-swiper-img": {
                border: `3px solid ${theme.palette.primary.main}`,
                padding: "1px",
              },
            },
            "& .swiper-button-prev , & .swiper-button-next": {
              display: "none",
            },
          },
        },
      },
    },
    "@media (max-width:768px)": {
      flexDirection: "column",
      "& .image-magnify": {
        flexDirection: "column-reverse",
        "& .MuiFormGroup-root": {
          width: "100%",
          height: "auto",
          position: "relative",
          "& .swiper": {
            position: "relative",
            // top: "100%",
            width: "100%",
            left: 0,
            right: 0,
            height: "auto",
            bottom: 0,
          },
        },
      },
      "& .image-magnify-wrapper": {
        margin: "auto",
      },
    },
    //
  })
);
const DetailsBox = styled((props) => <Box {...props}>{props.children}</Box>)(
  ({ theme }) => ({
    flex: 1,
    flexBasis: "50%",
    flexShrink: 0,
    "& .title": {
      fontFamily: "Montserrat,sans-serif",
      fontSize: "18px",
      lineHeight: "23px",
      color: "#4d5959",
      fontWeight: 600,
    },
    "& .price": {
      fontSize: "22px",
      lineHeight: "22px",
      marginTop: theme.spacing(1.5),
      display: "flex",
      color: "#696969",
      "& .state": {
        color: "blue",
        margin: "auto 0 auto auto",
        my: "auto",
        fontFamily: "Lato,sans-serif",
        fontSize: "14px",
        lineHeight: "25px",
      },
    },
    "& .description": {
      color: "#9FA6BE",
    },
    "& .sectionTitle": {
      fontFamily: "Montserrat,sans-serif",
      fontSize: "14px",
      color: "#4d5959",
      fontWeight: 700,
      letterSpacing: 3,
      textTransform: "uppercase",
      margin: `${theme.spacing(3)} 0 ${theme.spacing(2)} 0`,
    },
    "& .colors": {
      display: "flex",
      flexDirection: "row",
      gap: theme.spacing(1),
      marginBottom: theme.spacing(2),
      "& .MuiFormControlLabel-root": {
        marginLeft: 0,
        marginRight: 0,
        "& .outer": {
          cursor: "pointer",
          width: "35px",
          height: "35px",
          borderRadius: "50%",
          background: "white",
          border: "2px solid #DDDDDD",
          position: "relative",
        },
        "& .inner": {
          width: "25px",
          height: "25px",
          borderRadius: "50%",
          zIndex: 2,
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
        },
        "& .selected-color": {
          borderColor: "black",
          transition: ".5s",
        },
      },
    },
    "& .sizes": {
      display: "flex",
      flexDirection: "row",
      gap: theme.spacing(1),
      marginBottom: theme.spacing(2),
      "& .MuiFormControlLabel-root": {
        marginLeft: 0,
        marginRight: 0,
        "& .outer": {
          width: "30px",
          height: "30px",
          cursor: "pointer",
          borderRadius: "50%",
          background: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          border: "1px solid #999999",
          "&:hover": {
            "& .MuiTypography-root": {
              color: "black",
            },
          },

          "& .MuiTypography-root": {
            color: "#999999",
            textTransform: "uppercase",
            textAlign: "center",
            verticalAlign: "middle",
          },
        },
        "& .selected-size": {
          background: "black",
          transition: ".8s",
          "& .MuiTypography-root": {
            color: "white",
          },
          "&:hover": {
            "& .MuiTypography-root": {
              color: "white !important",
            },
          },
        },
      },
    },
    "& .controls": {
      minWidth: "160px",
      maxWidth: "100%",
      width: "auto",
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(5),
      display: "inline-flex",
      flexDirection: "column",
      gap: theme.spacing(2),
      "& .topControls": {
        display: "flex",
        gap: theme.spacing(1.5),
        "& .counterButton": {
          display: "flex",
          flexDirection: "row",
          border: "1px solid black",
          borderRadius: "20px",
          // padding: "4px 4px",

          "& .MuiButtonBase-root": {
            color: "black",
            "&:hover": {
              "& svg path": {
                color: theme.palette.primary.main,
              },
            },
          },
          "& .Mui-disabled": {
            color: "#999999",
          },
          "& .MuiTypography-root": {
            padding: "5px 5px",
            color: "black",
            width: "50px",
            textAlign: "center",
            margin: "auto",
          },
        },
        "& .addtocart": {
          color: "white",
          fontFamily: "Lato,sans-serif",
          fontSize: "14px",
          lineHeight: "25px",
          fontWeight: 600,
          textTransform: "uppercase",
          borderRadius: "20px",
          padding: `0 ${theme.spacing(3.5)}`,
          "&:hover": {
            background: "black",
            transition: ".6s",
          },
        },
        "& .fav": {
          border: "1px solid black",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          margin: "auto 0",
          "&:hover": {
            borderColor: theme.palette.primary.main,
            "@keyframes wishlist": {
              from: { transform: "scale(1)" },
              to: { transform: "scale(1.2)" },
            },
            "& svg": {
              color: theme.palette.primary.main,
              // transition: "transform .8s ease-in-out 0.2s",
              animation: "wishlist .8s linear 0.2s infinite alternate",
            },
          },
          "& svg": {
            color: "black",
            width: "50px",
            height: "100%",
          },
        },
      },
    },
    "& .buybtn": {
      color: "white",
      fontFamily: "Lato,sans-serif",
      fontSize: "14px",
      lineHeight: "30px",
      fontWeight: 400,
      width: "100%",
      textTransform: "uppercase",
      borderRadius: "20px",
      background: "black",
    },
    "& .instructions": {
      display: "flex",
      flexDirection: "row",
      gap: theme.spacing(2),
      marginBottom: theme.spacing(2),
      "& button": {
        color: "#4D5959",
        fontWeight: 600,
        fontFamily: "Lato,sans-serif",
        fontSize: "14px",
        lineHeight: "25px",
        textTransform: "capitalize",
        padding: 0,
        "&:hover": {
          color: theme.palette.primary.main,
        },
      },
    },
    "& .productSummary": {
      "& span": {
        color: "#999999",
      },
      "& .MuiTypography-root": {
        fontFamily: "Lato,sans-serif",
        fontSize: "14px",
        lineHeight: "25px",
        fontWeight: 400,
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
        color: "black",
      },
    },

    "@media (max-width:1025px)": {
      "& .controls": {
        width: "100%",
        "& .topControls": {
          flexWrap: "wrap",
          "& .addtocart": {
            order: 1,
            width: "100%",
            fontFamily: "Lato,sans-serif",
            fontSize: "14px",
            lineHeight: "30px",
            padding: "6px 16px",
            fontWeight: 400,
            borderRadius: "20px",
          },
        },
        "& .buybtn": {
          color: "white",
          fontFamily: "Lato,sans-serif",
          fontSize: "14px",
          lineHeight: "30px",
          fontWeight: 400,
          width: "100%",
          textTransform: "uppercase",
          borderRadius: "20px",
          background: "black",
        },
      },
    },
  })
);
const SizeGuideDialog = styled((props) => (
  <Dialog maxWidth="md" fullWidth className="sizeGuide" {...props}>
    {props.children}
  </Dialog>
))(({ theme }) => ({
  "& .MuiDialogTitle-root": {
    textAlign: "center",
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 400,
    fontSize: "23px",
    lineHeight: "33px",
    color: "#4d5959",
  },
  "& .MuiTable-root": {
    border: "1px solid #E0E0E0",
    "& .MuiTableCell-root": {
      border: "1px solid #E0E0E0",
      fontFamily: "Lato,sans-serif",
      fontWeight: 400,
      fontSize: "14px",
      color: "#999999",
      padding: theme.spacing(1.8),
    },
    "& .MuiTableHead-root": {
      "& .MuiTableCell-root": {
        fontWeight: 700,
      },
    },
    "& .MuiTableBody-root": {
      "& .MuiTableCell-root": {
        "&:hover": {
          background: "#d9d9d9",
        },
      },
    },
  },
  "& .MeasuringTips": {
    marginTop: theme.spacing(4),
    display: "flex",
    "& .Details": {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      "& .title": {
        fontFamily: "Montserrat,sans-serif",
        fontWeight: 400,
        fontSize: "23px",
        color: "#4d5959",
      },
      "& .section": {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        "& .section-title": {
          fontFamily: "Montserrat,sans-serif",
          fontWeight: 400,
          fontSize: "18px",
          lineHeight: "33px",
          color: "#4d5959",
        },
        "& .section-details": {
          fontFamily: "Lato ,sans-serif",
          fontWeight: 400,
          fontSize: "14px",
          lineHeight: "33px",
          color: "#999999",
        },
      },
    },
    "& .image": {},
  },
}));
const ReturnPolicyDialog = styled((props) => (
  <Dialog maxWidth="md" fullWidth className="sizeGuide" {...props}>
    {props.children}
  </Dialog>
))(({ theme }) => ({
  "& .section": {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    "& .section-title": {
      fontFamily: "Montserrat,sans-serif",
      fontWeight: 400,
      fontSize: "18px",
      lineHeight: "33px",
      color: "#4d5959",
      marginBottom: theme.spacing(1),
    },
    "& .section-details": {
      fontFamily: "Lato ,sans-serif",
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "33px",
      color: "#999999",
      marginBottom: theme.spacing(1),
    },
  },
}));
const QuestionFormDialog = styled((props) => (
  <Dialog maxWidth="sm" fullWidth className="sizeGuide" {...props}>
    {props.children}
  </Dialog>
))(({ theme }) => ({
  "& .MuiDialogTitle-root": {
    textAlign: "center",
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 400,
    fontSize: "23px",
    lineHeight: "33px",
    color: "#4d5959",
    // marginBottom: theme.spacing(0),
  },
  "& .MuiDialogContent-root": {
    "& .MuiFormControl-root": {
      width: "100%",
      marginBottom: theme.spacing(2),
      "& .MuiFormLabel-root": {
        textAlign: "center",
        fontFamily: "Lato, sans-serif",
        fontWeight: 400,
        fontSize: "20px",
        // lineHeight: "300px",
        color: "#999999",
        height: "auto",
      },
      "& .MuiFormHelperText-root": {
        color: "red",
      },
    },
  },

  "& button": {
    background: "white",
    color: "black",
    border: "1px solid black",
    width: "100%",
    margin: "auto",
    boxShadow: "none",

    "&:hover": {
      background: theme.palette.primary.main,
      color: "white",
      borderColor: theme.palette.primary.main,
    },
  },
}));
const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(2.5),
  },
  "& .MuiInputBase-input": {
    position: "relative",
    backgroundColor: theme.palette.mode === "light" ? "#fcfcfb" : "#2b2b2b",
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "100%",
    padding: "10px 12px",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: "black",
    },
  },
}));
const ProductDetailsSection = styled((props) => (
  <Box {...props}>{props.children}</Box>
))(({ theme }) => ({
  background: "#F6F6F8",
  width: "100%",
  padding: theme.spacing(5),
  marginTop: theme.spacing(5),
  "& .MuiTabs-flexContainer": {
    gap: "2px",
    "& .MuiTab-root": {
      borderRadius: 0,
      fontSize: "14px",
      lineHeight: "17px",
      fontWeight: 800,
      textTransform: "capitalize",
      padding: "5px 20px",
    },
  },
  "& .tab-panels": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: theme.spacing(4),
  },
  "& .description": {
    "& .MuiTypography-root": {
      textAlign: "center",
      fontFamily: "Lato,sans-serif",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "25px",
      color: "#999999",
    },
    "& .images-wrapper": {
      display: "flex",
      justifyContent: "center",
      margin: "auto",
      flexDirection: { xs: "row" },
      gap: theme.spacing(3),
      flexWrap: "nowrap",

      marginTop: theme.spacing(4),
    },
    "& .warnings": {
      display: "flex",
      flexDirection: "row",
      gap: theme.spacing(5),
      justifyContent: "center",
      padding: `${theme.spacing(12)} 0`,
      "& .col": {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(8),

        "& .section": {
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          width: "auto",
          gap: "10px",

          "& .MuiTypography-root": {
            width: "auto",
            flex: 1,
            margin: "auto 0",
            textAlign: "right",
          },
          "& .MuiBox-root": {
            width: "45px",
            height: "45px",
            margin: "auto 0",
            display: "flex",
            "& img": {},
          },
        },
      },
      "& .col:last-of-type": {
        "& .section": {
          flexDirection: "row-reverse",
          "& .MuiTypography-root": {
            textAlign: "left",
          },
        },
      },
    },
  },
  "& .additionalInfo": {
    width: "100%",
    "& .MuiTable-root": {
      background: "#F6F6F8",
      border: "1px solid #E0E0E0",
      "& .MuiTableCell-root": {
        border: "1px solid #E0E0E0",
        fontFamily: "Lato,sans-serif",
        fontWeight: 400,
        fontSize: "14px",
        color: "#999999",
        padding: theme.spacing(1.8),
      },
      "& .MuiTableHead-root": {
        "& .MuiTableCell-root": {
          fontWeight: 700,
        },
      },
      "& .MuiTableBody-root": {
        "& .MuiTableCell-root": {
          "&:hover": {
            background: "#d9d9d9",
          },
        },
      },
    },
  },
  "& .whyUs": {
    width: "100%",
    "& .caption": {
      margin: `${theme.spacing(2)} 0`,
    },
    "& .MuiTable-root": {
      background: "#F6F6F8",
      border: "1px solid #E0E0E0",
      "& .MuiTableCell-root": {
        width: "auto",
        "& img": {
          width: "100%",
          maxWidth: "100%",
        },
        "& span": {
          fontWeight: 700,
        },
        border: "1px solid #E0E0E0",
        fontFamily: "Lato,sans-serif",
        fontWeight: 400,
        fontSize: "14px",
        color: "#999999",
        padding: theme.spacing(1.8),
      },
      "& .MuiTableRow-root": {
        "& .MuiTableCell-root:first-of-type": {
          width: "72px",
          padding: "10px",
        },
      },
    },
  },
  "& .tabpanel-delivery": {
    background: "#F6F6F8",
    "& .wrapper": {
      display: "flex",
      gap: theme.spacing(8),
      justifyContent: "space-between",
      "& .col": {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        "& .title:first-of-type": {
          fontFamily: "Montserrat",
          fontWeight: "400",
          fontSize: "20px",
          lineHeight: "29px",
          color: "#4d5959",
          textAlign: "center",
          marginBottom: theme.spacing(3),
          "&:after": {
            content: '" "',
            border: `1px solid ${theme.palette.primary.main}`,
            width: "40px",
            height: "1px",
            background: theme.palette.primary.main,
            display: "block",
            margin: "10px auto",
          },
        },
        "& .section": {
          display: "flex",
          flexDirection: "row",
          margin: `10px 0`,
          "& svg": {
            fontSize: "3rem",
          },
          "& .section-icon": {
            width: "70px",
          },
          "& .section-content": {
            margin: "auto 0",

            "& .section-title": {
              fontFamily: "Montserrat,sans-serif",
              fontWeight: 400,
              // lineHeight: "300px",
              fontSize: "14px",
            },
            "& .section-para": {
              fontFamily: "Lato,sans-serif",
              fontWeight: 400,
              lineHeight: "25px",
              fontSize: "14px",
              color: "#999999",
            },
          },
        },
      },
    },
  },
  "& .tabpanel-custom": {
    margin: "auto",
    "& .svg-wrapper": {
      textAlign: "center",
      "& svg": {
        width: "40px",
        height: "40px",
        margin: "0 5px",
      },
    },
    "& .MuiTypography-root": {
      fontFamily: "Lato,sans-serif",
      fontWeight: 400,
      lineHeight: "25px",
      fontSize: "14px",
      color: "#999999",
    },
  },

  "@media (max-width:1025px)": {
    padding: `${theme.spacing(2)} 0`,
    width: "100%",
    "& .MuiAccordionDetails-root": {
      // padding: `${theme.spacing(2)} 4px`,

      "& .AccordionSummary": {
        // padding: 0,
        // width: "100%",
      },

      "& .description": {
        "& .MuiTypography-root": {},
        "& .images-wrapper": {
          flexDirection: "column",
          gap: 0,
          marginTop: theme.spacing(1),
        },
        "& .warnings": {
          flexDirection: "column",
          gap: theme.spacing(5),
          justifyContent: "center",
          padding: `${theme.spacing(8)} 0`,
          "& .col": {
            flexDirection: "column",
            gap: theme.spacing(5),

            "& .section": {
              flexDirection: "column-reverse",
              justifyContent: "center",
              width: "auto",
              gap: "5px",

              "& .MuiTypography-root": {
                width: "auto",
                flex: 1,
                margin: "auto 0",
                textAlign: "center",
              },
              "& .MuiBox-root": {
                margin: "auto auto",
              },
            },
          },
          "& .col:last-of-type": {
            "& .section": {
              flexDirection: "column-reverse",
              "& .MuiTypography-root": {
                textAlign: "center",
              },
            },
          },
        },
      },

      "& .additionalInfo": {
        width: "100%",
        "& .MuiTable-root": {
          minWidth: "100%",
          width: "100%",
        },
      },
      "& .whyUs": {
        width: "100%",
        "& .caption": {
          margin: `${theme.spacing(2)} 0`,
        },
        "& .MuiTable-root": {
          minWidth: "100%",
        },
      },
      "& .tabpanel-delivery": {
        background: "white",
        "& .wrapper": {
          flexDirection: "column",
          gap: theme.spacing(4),
          "& .col": {
            "& .title:first-of-type": {
              marginBottom: theme.spacing(1),
            },
          },
        },
      },
      "& .tabpanel-custom": {
        margin: "auto",

        "& .MuiTypography-root": {
          textAlign: "center",
        },
      },
    },
  },
}));
const StyledBreadcrumbs = styled((props) => (
  <Breadcrumbs
    separator={<NavigateNextIcon fontSize="small" />}
    aria-label="breadcrumb"
    {...props}
  >
    {props.children}
  </Breadcrumbs>
))(({ theme }) => ({
  "& .MuiBreadcrumbs-li a": {
    color: theme.typography.body1.color,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));
const ProductDetails = () => {
  const productCount = 10;
  const { id: prod_id } = useParams();
  const { data, isLoading, isError, isSuccess } = useGetProductQuery(prod_id);
  const colors = ["green", "red", "purple", "blue"];
  const sizes = ["xs", "s", "m", "lg", "xl"];
  const dispatch = useDispatch();
  const isWishlist = useSelector((state) =>
    wishlistProductSelector(state, parseInt(prod_id))
  );
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState();
  const [selectedColor, setSelectedColor] = useState(colors[0]);
  const [selectedSize, setSelectedSize] = useState(sizes[0]);
  const [sizeGuideModel, setSizeGuideModel] = useState(false);
  const [returnPolicyModel, setReturnPolicyModel] = useState(false);
  const [questionFormModel, setQuestionFormModel] = useState(false);
  const [selectedTab, setSelectedTab] = React.useState(0);
  const [expanded, setExpanded] = React.useState(false);
  const isSmaller = useMediaQuery("(max-width:1025px)");
  const isSmaller768 = useMediaQuery("(max-width:768px)");

  useEffect(() => {
    if (isSuccess) {
      setSelectedImage(data.data.image);
    }
  }, [isSuccess, data]);

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  const handleChangeExpand = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const handleChangeTab = (event, newValue) => {
    setSelectedTab(newValue);
  };
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      message: "",
    },
    onSubmit: () => {
      console.log("hello");
    },
    validationSchema: Yup.object().shape({
      name: Yup.string()
        .min(5, "too short!")
        .max(20, "too long!")
        .required("Required"),
      email: Yup.string().email("Invalid email!").required("Required"),
      phone: Yup.string()
        .matches(
          "/^[+]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$/",
          "Invalid phone number!"
        )
        .required("Required"),
      message: Yup.string().min(15, "too small!").max(50, "too long!"),
    }),
  });
  const [count, setcount] = useState(1);
  let content;
  if (isLoading) content = <ProductDetailsSkelton />;
  else if (isError) <h5>something wrong happened!</h5>;
  else if (isSuccess) {
    const { id, title, category, description, image, price } = data.data;
    content = (
      <Box>
        <Box sx={{ background: "#F6F6F8", padding: 2 }}>
          <Container>
            <Stack spacing={2}>
              <StyledBreadcrumbs>
                <Link to={"/home"}>Home</Link>
                <Link to={`/collections/${category}`}>{category}</Link>
                <Typography>{title}</Typography>
              </StyledBreadcrumbs>
            </Stack>
          </Container>
        </Box>

        <Container>
          <Wrapper>
            <Box className="image-magnify">
              {/* <Box className="image-section"> */}
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
              >
                <Swiper
                  direction={isSmaller ? "horizontal" : "vertical"}
                  slidesPerView={5}
                  spaceBetween={0}
                  loop
                  keyboard={{
                    enabled: true,
                  }}
                  className="verticalSwiper"
                  navigation={true}
                  modules={[Keyboard, Navigation]}
                  breakpoints={{
                    0: { slidesPerView: 3, spaceBetween: 30 },
                  }}
                >
                  {[image, img1, img2, img3, img1, img2, img3].map((item) => (
                    <SwiperSlide>
                      <FormControlLabel
                        sx={{ width: "100%", margin: 0 }}
                        value={item}
                        label={
                          <img
                            src={item}
                            width={"100%"}
                            height={"120px"}
                            objectFit={"contain"}
                            alt=""
                            className={
                              selectedImage == item
                                ? "selected-swiper-img"
                                : "swiper-img"
                            }
                          />
                        }
                        control={
                          <input
                            hidden
                            type={"radio"}
                            name="productImage"
                            value={item}
                            onChange={(e) => setSelectedImage(e.target.value)}
                          />
                        }
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </RadioGroup>
              <Box
                className="image-magnify-wrapper"
                style={{ padding: "20px" }}
              >
                {isSmaller768 ? (
                  <img src={selectedImage} alt="main product" width={"100%"} />
                ) : (
                  <ReactImageMagnify
                    {...{
                      imageClassName: "small-image",
                      className: "imageMagnify-root",
                      enlargedImageContainerDimensions: {
                        width: "100%",
                        height: "65%",
                        zIndex: 4,
                      },
                      enlargedImageContainerStyle: {
                        zIndex: 9999,
                      },
                      smallImage: {
                        alt: "product image",
                        isFluidWidth: true,
                        src: selectedImage,
                      },

                      largeImage: {
                        src: selectedImage,
                        width: 1200,
                        height: 1800,
                      },
                    }}
                  />
                )}
              </Box>
              {/* </Box> */}
            </Box>
            <DetailsBox>
              <Typography variant="h6" className="title">
                {/* Blue Cotton Leggings */}
                {title}
              </Typography>
              <Typography variant="h5" className="price">
                {/* £25.04 */}

                {Intl.NumberFormat("en-EG", {
                  style: "currency",
                  currency: "EUR",
                  maximumFractionDigits: 2,
                }).format(price)}
                <span className="state">in stock</span>
              </Typography>
              <Divider sx={{ my: 1 }} />
              <Rating name="read-only" value={3} readOnly />
              <Typography variant="body2" className="description grid-cols-3">
                {/* A pair of twill woven shorts featuring slanted front pockets,
                buttoned back pockets, a zip pocket, buttoned waist, and
                keychain loop. */}
                {description}
              </Typography>
              <Typography className="sectionTitle">color:blue</Typography>
              <Box className="colors">
                {colors.map((color) => (
                  <FormControlLabel
                    value={color}
                    label={
                      <Tooltip title={color} arrow placement="top">
                        <Box
                          className={
                            color === selectedColor
                              ? "selected-color outer"
                              : "outer"
                          }
                          key={color}
                        >
                          <Box
                            className="inner"
                            sx={{ background: color }}
                          ></Box>
                        </Box>
                      </Tooltip>
                    }
                    control={
                      <input
                        hidden
                        type={"radio"}
                        name="productColor"
                        value={color}
                        onChange={(e) => setSelectedColor(e.target.value)}
                      />
                    }
                  />
                ))}
              </Box>
              <Typography className="sectionTitle">size:s</Typography>
              <Box className="sizes">
                {sizes.map((size) => (
                  <FormControlLabel
                    value={size}
                    label={
                      <Box
                        className={
                          size === selectedSize
                            ? "selected-size outer"
                            : "outer"
                        }
                        key={size}
                      >
                        <Typography>{size}</Typography>
                      </Box>
                    }
                    control={
                      <input
                        hidden
                        type={"radio"}
                        name="productColor"
                        value={size}
                        onChange={(e) => setSelectedSize(e.target.value)}
                      />
                    }
                  />
                ))}
              </Box>
              <Box className="controls">
                <Box className="topControls">
                  <Box className="counterButton">
                    <IconButton
                      disabled={count === 1}
                      disableFocusRipple
                      disableRipple
                      size="small"
                      onClick={() => {
                        setcount((prev) => prev > 1 && prev - 1);
                      }}
                    >
                      <RemoveIcon />
                    </IconButton>
                    <Typography variant="body1">{count}</Typography>
                    <IconButton
                      disabled={count === productCount}
                      disableFocusRipple
                      disableRipple
                      size="small"
                      onClick={() => {
                        setcount((prev) => prev < productCount && prev + 1);
                      }}
                    >
                      <AddIcon />
                    </IconButton>
                  </Box>
                  <Button
                    className="addtocart"
                    variant="contained"
                    color="primary"
                    onClick={() =>
                      dispatch(
                        addItem({ ...data.data, img: image, count: count })
                      )
                    }
                  >
                    Add to cart
                  </Button>
                  <Tooltip title="Add to wishlist" arrow placement="top">
                    {!isWishlist ? (
                      //   {/* <IconButton
                      //   disableFocusRipple
                      //   disableRipple
                      //   disap
                      //   className="fav"
                      //   onClick={() => {
                      //     setcount((prev) => prev < productCount && prev + 1);
                      //   }}
                      // > */}
                      <FavoriteBorderIcon
                        onClick={() => {
                          dispatch(
                            toggleItemToWishlist({
                              img: image,
                              title,
                              id: id,
                              price: price,
                            })
                          );
                        }}
                        sx={{
                          display: "block",
                          mb: 1,
                          width: "30px",
                          height: "30px",
                          cursor: "pointer",
                          "&:hover": {
                            path: { stroke: "gray", strokeWidth: "1px" },
                          },
                        }}
                      />
                    ) : (
                      <FavoriteRounded
                        htmlColor="red"
                        onClick={() => {
                          dispatch(
                            toggleItemToWishlist({
                              img: image,
                              title,
                              id: id,
                              price: price,
                            })
                          );
                        }}
                        sx={{
                          display: "block",
                          mb: 1,
                          width: "30px",
                          height: "30px",
                          cursor: "pointer",
                          "&:hover": {
                            path: { stroke: "gray" },
                          },
                        }}
                      />
                    )}
                    {/* </IconButton> */}
                  </Tooltip>
                </Box>
                <Box>
                  <Button
                    className="buybtn"
                    variant="contained"
                    onClick={() => {
                      dispatch(
                        addItem({ ...data.data, img: image, count: count })
                      );
                      navigate("/cart");
                    }}
                  >
                    Buy it now
                  </Button>
                </Box>
              </Box>
              <Box className="instructions">
                <Button variant="text" onClick={() => setSizeGuideModel(true)}>
                  Size Guide
                </Button>
                <Button
                  variant="text"
                  onClick={() => setReturnPolicyModel(true)}
                >
                  Delivery & Return
                </Button>
                <Button
                  variant="text"
                  onClick={() => setQuestionFormModel(true)}
                >
                  Ask a Question
                </Button>
              </Box>
              <Box className="productSummary">
                <Typography>
                  <span>SKU: </span>M-06
                </Typography>
                <Typography>
                  <span>Categories: </span>
                  {category}
                </Typography>
                <Typography>
                  <span>Tags: </span>Accessories, black, blue, brown, Clothing,
                  Color Black, Color Blue, Color Brown, Color Cyan, Color Grey,
                  Color Pink, Color Red, Cyan, grey, L, M, Pink, Price $7-$50,
                  Red, S, short, Size L, Size M, Size S, Size XL, Size XS,
                  Vendor Gecko, XL, XS
                </Typography>
              </Box>
            </DetailsBox>
          </Wrapper>
        </Container>
        <ProductDetailsSection>
          <Container maxWidth="lg">
            {isSmaller ? (
              <Box className="accordion">
                <Accordion
                  expanded={expanded === "panel1"}
                  onChange={handleChangeExpand("panel1")}
                >
                  <AccordionSummary
                    className="AccordionSummary"
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>Description</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box className="description">
                      <Typography>
                        Design inspiration lorem ipsum dolor sit amet,
                        consectetuer adipiscing elit. Morbi commodo, ipsum sed
                        pharetra gravida, orci magna rhoncus neque, id pulvinar
                        odio lorem non turpis. Nullam sit amet enim. Suspendisse
                        id velit vitae ligula volutpat condimentum. Aliquam erat
                        volutpat. Sed quis velit. Nulla facilisi. Nulla libero.
                        Vivamus pharetra posuere sapien. Nam consectetuer. Sed
                        aliquam, nunc eget euismod ullamcorper, lectus nunc
                        ullamcorper orci.
                      </Typography>
                      <Box className="images-wrapper">
                        <Box sx={{ height: "400px" }}>
                          <img
                            width={"100%"}
                            style={{ objectFit: "contain", height: "100%" }}
                            src={img1}
                            alt="product"
                          />
                        </Box>
                        <Box sx={{ height: "400px" }}>
                          <img
                            width={"100%"}
                            style={{ objectFit: "contain", height: "100%" }}
                            src={img2}
                            alt="product"
                          />
                        </Box>
                        <Box sx={{ height: "400px" }}>
                          <img
                            width={"100%"}
                            style={{ objectFit: "contain", height: "100%" }}
                            src={img3}
                            alt="product"
                          />
                        </Box>
                      </Box>
                      <Box className="warnings">
                        <Box className="col">
                          <Box className="section">
                            <Typography>Rain & Water Resistant</Typography>
                            <Box>
                              <img
                                width={"100%"}
                                src={depric1}
                                alt="Rain & Water Resistant"
                              />
                            </Box>
                          </Box>
                          <Box className="section">
                            <Typography>UV Resistant Coatings</Typography>
                            <Box>
                              <img
                                width={"100%"}
                                src={depric2}
                                alt="Rain & Water Resistant"
                              />
                            </Box>
                          </Box>
                          <Box className="section">
                            <Typography>
                              Corrosion Resistance to Sea water
                            </Typography>
                            <Box>
                              <img
                                width={"100%"}
                                src={depric3}
                                alt="Rain & Water Resistant"
                              />
                            </Box>
                          </Box>
                        </Box>
                        <Box className="col">
                          <Box className="section">
                            <Typography>Rain & Water Resistant</Typography>
                            <Box>
                              <img
                                width={"100%"}
                                src={depric4}
                                alt="Rain & Water Resistant"
                              />
                            </Box>
                          </Box>
                          <Box className="section">
                            <Typography>UV Resistant Coatings</Typography>
                            <Box>
                              <img
                                width={"100%"}
                                src={depric5}
                                alt="Rain & Water Resistant"
                              />
                            </Box>
                          </Box>
                          <Box className="section">
                            <Typography>
                              Corrosion Resistance to Sea water
                            </Typography>
                            <Box>
                              <img
                                width={"100%"}
                                src={depric6}
                                alt="Rain & Water Resistant"
                              />
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </AccordionDetails>
                </Accordion>

                <Accordion
                  expanded={expanded === "panel2"}
                  onChange={handleChangeExpand("panel2")}
                >
                  <AccordionSummary
                    className="AccordionSummary"
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>Additional Information</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box className="additionalInfo">
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableRow>
                          <TableCell>Color</TableCell>
                          <TableCell>
                            Blue, Red, Cyan, Black, Pink, Grey, Brown
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell hover>Size</TableCell>
                          <TableCell hover>XS, S, M, L, XL</TableCell>
                        </TableRow>
                      </Table>
                    </Box>
                  </AccordionDetails>
                </Accordion>

                <Accordion
                  expanded={expanded === "panel3"}
                  onChange={handleChangeExpand("panel3")}
                >
                  <AccordionSummary
                    className="AccordionSummary"
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>Why Buy From Us</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box className="whyUs">
                      <Typography className="caption">
                        5 Reasons To Be Our Customer:
                      </Typography>
                      <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                          <TableRow>
                            <TableCell>
                              <img
                                height={"auto"}
                                // width={"100%"}
                                src={reason1}
                                alt="Exceptional Support"
                              />
                            </TableCell>
                            <TableCell>
                              <span>Exceptional Support</span> Our friendly
                              support staff are available all the time to help
                              customers with any questions or concerns. We want
                              our products to deliver the most joy and value
                              with zero hassle. That’s why we insist on being
                              available to assist when the need arises.
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>
                              <img
                                height={"auto"}
                                // width={"100%"}
                                src={reason2}
                                alt="30-Day Money Back Guarantee"
                              />
                            </TableCell>
                            <TableCell>
                              <span>30-Day Money Back Guarantee</span> We are so
                              confident that you will love our products that we
                              offer a 30-day money back guarantee. If elgible
                              product doesn't meet your needs, just ask for your
                              money back.
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <img
                                height={"auto"}
                                // width={"100%"}
                                src={reason3}
                                alt="Quality and Affordable"
                              />
                            </TableCell>
                            <TableCell>
                              <span>Quality and Affordable</span> We believe in
                              combining both quality and affordability in our
                              products. There’s no reason to pay exorbitant
                              prices when our products do more for less. You
                              won't find better price to quality ratio.
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <img
                                height={"auto"}
                                // width={"100%"}
                                src={reason4}
                                alt="Unbeatable Price"
                              />
                            </TableCell>
                            <TableCell>
                              <span>Unbeatable Price</span> - Years of
                              expiriences in pet clothing and accessories
                              industry gives us uniqe position to work directly
                              with factories to ensure quality control and the
                              best price possible.
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <img
                                height={"auto"}
                                // width={"100%"}
                                src={reason5}
                                alt="Secure, Easy Ordering"
                              />
                            </TableCell>
                            <TableCell>
                              <span>Secure, Easy Ordering</span> - Orders can be
                              placed online using either a credit/debit card or
                              PayPal. All transactions are SSL-secured and
                              guarantee your privacy.
                            </TableCell>
                          </TableRow>
                        </Table>
                      </TableContainer>
                    </Box>
                  </AccordionDetails>
                </Accordion>

                <Accordion
                  expanded={expanded === "panel4"}
                  onChange={handleChangeExpand("panel4")}
                >
                  <AccordionSummary
                    className="AccordionSummary"
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>Delivery & Returns</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box className="tabpanel-delivery">
                      <Box className="wrapper">
                        <Box className="col">
                          <Typography className="title">Delivery</Typography>
                          <Box className="section">
                            <Box className="section-icon">
                              <BsTruck />
                            </Box>
                            <Box className="section-content">
                              <Typography className="section-title">
                                FREE SHIPPING
                              </Typography>
                              <Typography className="section-para">
                                Our free shipping takes between 7 & 14 days from
                                the day of dispatch
                              </Typography>
                            </Box>
                          </Box>
                          <Box className="section">
                            <Box className="section-icon">
                              <SlLocationPin />
                            </Box>
                            <Box className="section-content">
                              <Typography className="section-title">
                                TRACKED ORDERS
                              </Typography>
                              <Typography className="section-para">
                                After dispatch you will get a tracking code to
                                follow your order's full journey
                              </Typography>
                            </Box>
                          </Box>
                        </Box>

                        <Box className="col">
                          <Typography className="title">Returns</Typography>
                          <Box className="section">
                            <Box className="section-icon">
                              <RiRefund2Line />
                            </Box>
                            <Box className="section-content">
                              <Typography className="section-title">
                                14 DAYS RETURN
                              </Typography>
                              <Typography className="section-para">
                                You can return any unwanted item within 14 days
                                and get a full refund
                              </Typography>
                            </Box>
                          </Box>
                          <Box className="section">
                            <Box className="section-icon">
                              <FaBarcode />
                            </Box>
                            <Box className="section-content">
                              <Typography className="section-title">
                                FREE RETURNS
                              </Typography>
                              <Typography className="section-para">
                                Pre-paid return label will be provided if you
                                need to return your items
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </AccordionDetails>
                </Accordion>

                <Accordion
                  expanded={expanded === "panel5"}
                  onChange={handleChangeExpand("panel5")}
                >
                  <AccordionSummary
                    className="AccordionSummary"
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>Custom tab</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box className="tabpanel-custom">
                      <Box className="svg-wrapper">
                        <Svg1 />
                        <Svg2 />
                        <Svg3 />
                        <Svg4 />
                        <Svg5 />
                        <Svg6 />
                        <Svg7 />
                      </Box>
                      <Typography>
                        LT01: 70% wool, 15% polyester, 10% polyamide, 5% acrylic
                        900 Grms/mt
                      </Typography>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Box>
            ) : (
              <Box className="Tabs-panels">
                <ProductsSelectionBox>
                  <Tabs
                    sx={{
                      "& .MuiTabs-flexContainer": {
                        gap: { xs: 2, sm: 2, md: 4, lg: 4 },
                      },
                      "& .MuiTabs-indicator": { display: "none" },
                    }}
                    value={selectedTab}
                    onChange={handleChangeTab}
                    aria-label="basic tabs example"
                  >
                    <StyledTab label="Description" {...a11yProps(0)} />
                    <StyledTab
                      label="Additional Information"
                      {...a11yProps(1)}
                    />
                    <StyledTab label="Why Buy From Us" {...a11yProps(2)} />
                    <StyledTab label="Delivery & Returns" {...a11yProps(3)} />
                    <StyledTab label="Custom tab" {...a11yProps(4)} />
                    {/* <StyledTab label="Reviews" {...a11yProps(5)} /> */}
                  </Tabs>
                </ProductsSelectionBox>
                <Box className="tab-panels">
                  <TabPanel
                    className="description"
                    value={selectedTab}
                    index={0}
                  >
                    <Typography>
                      Design inspiration lorem ipsum dolor sit amet,
                      consectetuer adipiscing elit. Morbi commodo, ipsum sed
                      pharetra gravida, orci magna rhoncus neque, id pulvinar
                      odio lorem non turpis. Nullam sit amet enim. Suspendisse
                      id velit vitae ligula volutpat condimentum. Aliquam erat
                      volutpat. Sed quis velit. Nulla facilisi. Nulla libero.
                      Vivamus pharetra posuere sapien. Nam consectetuer. Sed
                      aliquam, nunc eget euismod ullamcorper, lectus nunc
                      ullamcorper orci.
                    </Typography>
                    <Box className="images-wrapper">
                      <Box sx={{ height: "400px" }}>
                        <img
                          width={"100%"}
                          style={{ objectFit: "contain", height: "100%" }}
                          src={img1}
                          alt="product"
                        />
                      </Box>
                      <Box sx={{ height: "400px" }}>
                        <img
                          width={"100%"}
                          style={{ objectFit: "contain", height: "100%" }}
                          src={img2}
                          alt="product"
                        />
                      </Box>
                      <Box sx={{ height: "400px" }}>
                        <img
                          width={"100%"}
                          style={{ objectFit: "contain", height: "100%" }}
                          src={img3}
                          alt="product"
                        />
                      </Box>
                    </Box>
                    <Box className="warnings">
                      <Box className="col">
                        <Box className="section">
                          <Typography>Rain & Water Resistant</Typography>
                          <Box>
                            <img
                              width={"100%"}
                              src={depric1}
                              alt="Rain & Water Resistant"
                            />
                          </Box>
                        </Box>
                        <Box className="section">
                          <Typography>UV Resistant Coatings</Typography>
                          <Box>
                            <img
                              width={"100%"}
                              src={depric2}
                              alt="Rain & Water Resistant"
                            />
                          </Box>
                        </Box>
                        <Box className="section">
                          <Typography>
                            Corrosion Resistance to Sea water
                          </Typography>
                          <Box>
                            <img
                              width={"100%"}
                              src={depric3}
                              alt="Rain & Water Resistant"
                            />
                          </Box>
                        </Box>
                      </Box>
                      <Box className="col">
                        <Box className="section">
                          <Typography>Rain & Water Resistant</Typography>
                          <Box>
                            <img
                              width={"100%"}
                              src={depric4}
                              alt="Rain & Water Resistant"
                            />
                          </Box>
                        </Box>
                        <Box className="section">
                          <Typography>UV Resistant Coatings</Typography>
                          <Box>
                            <img
                              width={"100%"}
                              src={depric5}
                              alt="Rain & Water Resistant"
                            />
                          </Box>
                        </Box>
                        <Box className="section">
                          <Typography>
                            Corrosion Resistance to Sea water
                          </Typography>
                          <Box>
                            <img
                              width={"100%"}
                              src={depric6}
                              alt="Rain & Water Resistant"
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </TabPanel>
                  <TabPanel
                    className="additionalInfo"
                    value={selectedTab}
                    index={1}
                  >
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableRow>
                          <TableCell>Color</TableCell>
                          <TableCell>
                            Blue, Red, Cyan, Black, Pink, Grey, Brown
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell hover>Size</TableCell>
                          <TableCell hover>XS, S, M, L, XL</TableCell>
                        </TableRow>
                      </Table>
                    </TableContainer>
                  </TabPanel>
                  <TabPanel className="whyUs" value={selectedTab} index={2}>
                    <Typography className="caption">
                      5 Reasons To Be Our Customer:
                    </Typography>
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableRow>
                          <TableCell>
                            <img
                              height={"auto"}
                              // width={"100%"}
                              src={reason1}
                              alt="Exceptional Support"
                            />
                          </TableCell>
                          <TableCell>
                            <span>Exceptional Support</span> Our friendly
                            support staff are available all the time to help
                            customers with any questions or concerns. We want
                            our products to deliver the most joy and value with
                            zero hassle. That’s why we insist on being available
                            to assist when the need arises.
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>
                            <img
                              height={"auto"}
                              // width={"100%"}
                              src={reason2}
                              alt="30-Day Money Back Guarantee"
                            />
                          </TableCell>
                          <TableCell>
                            <span>30-Day Money Back Guarantee</span> We are so
                            confident that you will love our products that we
                            offer a 30-day money back guarantee. If elgible
                            product doesn't meet your needs, just ask for your
                            money back.
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <img
                              height={"auto"}
                              // width={"100%"}
                              src={reason3}
                              alt="Quality and Affordable"
                            />
                          </TableCell>
                          <TableCell>
                            <span>Quality and Affordable</span> We believe in
                            combining both quality and affordability in our
                            products. There’s no reason to pay exorbitant prices
                            when our products do more for less. You won't find
                            better price to quality ratio.
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <img
                              height={"auto"}
                              // width={"100%"}
                              src={reason4}
                              alt="Unbeatable Price"
                            />
                          </TableCell>
                          <TableCell>
                            <span>Unbeatable Price</span> - Years of expiriences
                            in pet clothing and accessories industry gives us
                            uniqe position to work directly with factories to
                            ensure quality control and the best price possible.
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <img
                              height={"auto"}
                              // width={"100%"}
                              src={reason5}
                              alt="Secure, Easy Ordering"
                            />
                          </TableCell>
                          <TableCell>
                            <span>Secure, Easy Ordering</span> - Orders can be
                            placed online using either a credit/debit card or
                            PayPal. All transactions are SSL-secured and
                            guarantee your privacy.
                          </TableCell>
                        </TableRow>
                      </Table>
                    </TableContainer>
                  </TabPanel>
                  <TabPanel
                    className="tabpanel-delivery"
                    value={selectedTab}
                    index={3}
                  >
                    <Box className="wrapper">
                      <Box className="col">
                        <Typography className="title">Delivery</Typography>
                        <Box className="section">
                          <Box className="section-icon">
                            <BsTruck />
                          </Box>
                          <Box className="section-content">
                            <Typography className="section-title">
                              FREE SHIPPING
                            </Typography>
                            <Typography className="section-para">
                              Our free shipping takes between 7 & 14 days from
                              the day of dispatch
                            </Typography>
                          </Box>
                        </Box>
                        <Box className="section">
                          <Box className="section-icon">
                            <SlLocationPin />
                          </Box>
                          <Box className="section-content">
                            <Typography className="section-title">
                              TRACKED ORDERS
                            </Typography>
                            <Typography className="section-para">
                              After dispatch you will get a tracking code to
                              follow your order's full journey
                            </Typography>
                          </Box>
                        </Box>
                      </Box>

                      <Box className="col">
                        <Typography className="title">Returns</Typography>
                        <Box className="section">
                          <Box className="section-icon">
                            <RiRefund2Line />
                          </Box>
                          <Box className="section-content">
                            <Typography className="section-title">
                              14 DAYS RETURN
                            </Typography>
                            <Typography className="section-para">
                              You can return any unwanted item within 14 days
                              and get a full refund
                            </Typography>
                          </Box>
                        </Box>
                        <Box className="section">
                          <Box className="section-icon">
                            <FaBarcode />
                          </Box>
                          <Box className="section-content">
                            <Typography className="section-title">
                              FREE RETURNS
                            </Typography>
                            <Typography className="section-para">
                              Pre-paid return label will be provided if you need
                              to return your items
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </TabPanel>
                  <TabPanel
                    className="tabpanel-custom"
                    value={selectedTab}
                    index={4}
                  >
                    <Box className="svg-wrapper">
                      <Svg1 />
                      <Svg2 />
                      <Svg3 />
                      <Svg4 />
                      <Svg5 />
                      <Svg6 />
                      <Svg7 />
                    </Box>
                    <Typography>
                      LT01: 70% wool, 15% polyester, 10% polyamide, 5% acrylic
                      900 Grms/mt
                    </Typography>
                  </TabPanel>
                </Box>
              </Box>
            )}
          </Container>
        </ProductDetailsSection>
        {/* models */}
        {/* size Guide */}
        <SizeGuideDialog
          scroll="body"
          open={sizeGuideModel}
          onClose={() => setSizeGuideModel(false)}
        >
          <DialogTitle>Size Guide</DialogTitle>
          <DialogContent>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Size</TableCell>
                    <TableCell>US</TableCell>
                    <TableCell>Bust</TableCell>
                    <TableCell>Waist</TableCell>
                    <TableCell>Low Hip</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {[
                    {
                      size: "XS",
                      us: "2",
                      bust: "32",
                      waist: "24 - 25",
                      lowHip: "33 - 34",
                    },
                    {
                      size: "S",
                      us: "4",
                      bust: "34 - 35",
                      waist: "26 - 27",
                      lowHip: "35 - 26",
                    },
                    {
                      size: "M",
                      us: "6",
                      bust: "36 - 37",
                      waist: "28 - 29",
                      lowHip: "38 - 40",
                    },
                    {
                      size: "L",
                      us: "8",
                      bust: "38 - 39",
                      waist: "30 - 31",
                      lowHip: "42 - 44",
                    },
                    {
                      size: "XL",
                      us: "10",
                      bust: "40 - 41",
                      waist: "32 - 33",
                      lowHip: "45 - 47",
                    },
                    {
                      size: "XXL",
                      us: "12",
                      bust: "42 - 43",
                      waist: "34 - 35",
                      lowHip: "48 - 50",
                    },
                  ].map((item) => (
                    <TableRow
                      hover
                      key={item.size}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell hover>{item.size}</TableCell>
                      <TableCell hover>{item.us}</TableCell>
                      <TableCell hover>{item.bust}</TableCell>
                      <TableCell hover>{item.waist}</TableCell>
                      <TableCell hover>{item.lowHip}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box className="MeasuringTips">
              <Box className="Details">
                <Typography className="title">Measuring Tips</Typography>
                <Box className="section">
                  <Typography className="section-title">Burst</Typography>
                  <Typography className="section-details">
                    Measure around the fullest part of your bust.
                  </Typography>
                </Box>
                <Box className="section">
                  <Typography className="section-title">Waist</Typography>
                  <Typography className="section-details">
                    Measure around the narrowest part of your torso.
                  </Typography>
                </Box>
                <Box className="section">
                  <Typography className="section-title">Low Hip</Typography>
                  <Typography className="section-details">
                    With your feet together measure around the fullest part of
                    your hips/rear.
                  </Typography>
                </Box>
              </Box>
              <Box className="image">
                <img src={sizeChart} alt="size chart" />
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setSizeGuideModel(false)}>Cancel</Button>
          </DialogActions>
        </SizeGuideDialog>
        <ReturnPolicyDialog
          scroll="body"
          backdrop
          open={returnPolicyModel}
          onClose={() => setReturnPolicyModel(false)}
        >
          <DialogContent>
            <Box className="section">
              <Typography className="section-title">Delivery</Typography>
              <Typography className="section-details">
                All orders shipped with UPS Express.
              </Typography>
              <Typography className="section-details">
                Always free shipping for orders over US $250.
              </Typography>
              <Typography className="section-details">
                All orders are shipped with a UPS tracking number.
              </Typography>
            </Box>
            <Box className="section">
              <Typography className="section-title">Returns</Typography>
              <Typography className="section-details">
                Items returned within 14 days of their original shipment date in
                same as new condition will be eligible for a full refund or
                store credit.
              </Typography>
              <Typography className="section-details">
                Refunds will be charged back to the original form of payment
                used for purchase.
              </Typography>
              <Typography className="section-details">
                Customer is responsible for shipping charges when making returns
                and shipping/handling fees of original purchase is
                non-refundable.
              </Typography>
              <Typography className="section-details">
                All sale items are final purchases.
              </Typography>
            </Box>
            <Box className="section">
              <Typography className="section-title">Help</Typography>
              <Typography className="section-details">
                Give us a shout if you have any other questions and/or concerns.
              </Typography>
              <Typography className="section-details">
                Email: contact@domain.com{" "}
              </Typography>
              <Typography className="section-details">
                Phone: +1 (23) 456 789
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setReturnPolicyModel(false)}>Cancel</Button>
          </DialogActions>
        </ReturnPolicyDialog>
        <QuestionFormDialog
          open={questionFormModel}
          onClose={() => setQuestionFormModel(false)}
        >
          <DialogTitle>Ask a Question</DialogTitle>
          <form onSubmit={formik.handleSubmit}>
            <DialogContent>
              <FormControl variant="standard">
                <InputLabel shrink htmlFor="bootstrap-input">
                  Your Name (required)
                </InputLabel>
                <BootstrapInput
                  name="name"
                  onChange={formik.handleChange}
                  value={formik.values.name}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                  defaultValue="react-bootstrap"
                  id="bootstrap-input"
                />
                <FormHelperText>
                  {formik.touched.name && formik.errors.name}
                </FormHelperText>
              </FormControl>

              <FormControl variant="standard">
                <InputLabel shrink htmlFor="bootstrap-input">
                  Your Email (required)
                </InputLabel>
                <BootstrapInput
                  name="email"
                  onChange={formik.handleChange}
                  value={formik.values.email}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  defaultValue="react-bootstrap"
                  id="bootstrap-input"
                />
                <FormHelperText>
                  {formik.touched.email && formik.errors.email}
                </FormHelperText>
              </FormControl>

              <FormControl variant="standard">
                <InputLabel shrink htmlFor="bootstrap-input">
                  Your Phone Number
                </InputLabel>
                <BootstrapInput
                  name="phone"
                  onChange={formik.handleChange}
                  value={formik.values.phone}
                  error={formik.touched.phone && Boolean(formik.errors.phone)}
                  defaultValue="react-bootstrap"
                  id="bootstrap-input"
                />
                <FormHelperText>
                  {formik.touched.phone && formik.errors.phone}
                </FormHelperText>
              </FormControl>

              <FormControl variant="standard">
                <InputLabel shrink htmlFor="bootstrap-input">
                  Your Message
                </InputLabel>
                <BootstrapInput
                  multiline
                  minRows={8}
                  maxRows={12}
                  height={"15px"}
                  name="message"
                  onChange={formik.handleChange}
                  value={formik.values.message}
                  error={
                    formik.touched.message && Boolean(formik.errors.message)
                  }
                  defaultValue="react-bootstrap"
                  id="bootstrap-input"
                />
                <FormHelperText>
                  {formik.touched.message && formik.errors.message}
                </FormHelperText>
              </FormControl>
              <Button variant="contained" type="submit">
                Submit
              </Button>
            </DialogContent>
          </form>
        </QuestionFormDialog>
      </Box>
    );
  }
  return (
    <>
      <Helmet title={"product"} />
      {content}
    </>
  );
};

export default ProductDetails;
